import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SidebarStateStore {
  /** Whether the desktop sidebar is expanded (true) or icon-collapsed (false). */
  expanded: boolean;
  setExpanded: (v: boolean) => void;
  toggle: () => void;
}

/**
 * Persistent desktop sidebar state.
 *
 * Stored in localStorage so the collapsed/expanded preference survives
 * across sessions. Consumed by {@link PlatformLayout} as the controlled
 * `open`/`onOpenChange` of shadcn's `SidebarProvider`, which means any
 * other component can also read or toggle the sidebar via this store.
 *
 * Note: the mobile drawer state is managed independently by
 * `SidebarProvider` (Sheet) and is not persisted on purpose.
 */
export const useSidebarState = create<SidebarStateStore>()(
  persist(
    (set) => ({
      expanded: true,
      setExpanded: (v) => set({ expanded: v }),
      toggle: () => set((s) => ({ expanded: !s.expanded })),
    }),
    { name: 'expai-sidebar-state' },
  ),
);
